module.exports = __webpack_public_path__ + "static/media/kyte.3b1e8d60.svg";